export const GET_STAFF_START = "GET_STAFF_START"
export const GET_STAFF_SUCCESS = "GET_STAFF_SUCCESS"
export const GET_STAFF_FAILED = "GET_STAFF_FAILED"
export const GET_STAFF_RESET = "GET_STAFF_RESET"

export const GET_STAFF_ATTENDANCE_START = "GET_ATTENDANCE_START"
export const GET_STAFF_ATTENDANCE_SUCCESS = "GET_STAFF_ATTENDANCE_SUCCESS"
export const GET_STAFF_ATTENDANCE_FAILED = "GET_STAFF_ATTENDANCE_FAILED"
export const GET_STAFF_ATTENDANCE_RESET = "GET_STAFF_ATTENDANCE_RESET"



export const GET_TIMETABLE_DAYS_REQUEST = "GET_TIMETABLE_DAYS_REQUEST";
export const GET_TIMETABLE_DAYS_SUCCESS = "GET_TIMETABLE_DAYS_SUCCESS";
export const GET_TIMETABLE_DAYS_FAIL = "GET_TIMETABLE_DAYS_FAIL";
